import { useMemo } from 'react'

import {
  TransformedCurrencyInfo,
  useGetCurrencyInfoQuery,
} from 'src/Redux/userExchangeRateApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { FIXED_BY } from 'src/Constants/constants'

import { FALLBACK_CURRENCY } from './usePaymentAnountsWithCurrency'

interface UseCurrency {
  currency: TransformedCurrencyInfo
  currencyRate: number
  currencySymbol: string
  calculateCurrencyValue: (
    amount: number | undefined,
    isDiscountValue?: boolean,
  ) => string
}

const DEFAULT_CURRENCY: TransformedCurrencyInfo = {
  currencySymbol: '$',
  currencyRate: 1,
}

export const useCurrency = (
  platformType: CampaignPlatformTypeEnum,
): UseCurrency => {
  const { data: currency } = useGetCurrencyInfoQuery()

  const isMeta = platformType === CampaignPlatformTypeEnum.META

  const currentCurrency = useMemo(() => {
    if (isMeta) {
      return DEFAULT_CURRENCY
    }
    return {
      currencyRate: currency?.currencyRate || FALLBACK_CURRENCY.currencyRate,
      currencySymbol:
        currency?.currencySymbol || FALLBACK_CURRENCY.currencySymbol,
    }
  }, [currency, isMeta])

  const { currencyRate, currencySymbol } = currentCurrency

  const calculateCurrencyValue = (
    amount: number | undefined,
    isDiscountValue?: boolean,
  ): string => {
    const prefixSign = isDiscountValue ? '- ' : ''

    if (!amount || !currencyRate) {
      return `${currencySymbol}0.00`
    }
    return `${prefixSign}${currencySymbol}${(amount * currencyRate).toFixed(FIXED_BY)}`
  }

  return {
    currencyRate,
    currencySymbol,
    calculateCurrencyValue,
    currency: isMeta ? DEFAULT_CURRENCY : currency || DEFAULT_CURRENCY,
  }
}
